// @flow
import React from 'react'
// $FlowFixMe
import { Radiomark, StyledRadio } from 'src/components/Form'
import type { Field as FieldProps } from 'src/types'

const renderRadio = ({
  className,
  input,
  label,
  name,
  value,
  fixedValue,
  children,
  meta: { touched, error }
}: FieldProps) => {
  return (
    <StyledRadio>
      <input
        {...input}
        value={input.value}
        checked={input.value === fixedValue}
        onChange={() => input.onChange(fixedValue)}
        type="radio"
      />
      <Radiomark hasError={touched && error} />
      {label}
    </StyledRadio>
  )
}

export default renderRadio



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/Radio.js